import ajax from 'aria-viewer/utils/ajax'
import { TourActions } from 'aria-viewer/tour'
import { closeModal } from 'aria-viewer/modal/modalActions'
import { setHoveredHotspotId } from 'aria-viewer/players/panoplayer/actions/panoramaActions'
import { PaymentConstants } from './paymentConstants'
import { formatCreditCardsMap } from './paymentUtils'
import { geocodeByAddress } from 'react-places-autocomplete'
import Places from 'aria-viewer/utils/places'

export const CHANGE_FORM_FIELD = 'Payments.CHANGE_FORM_FIELD'
export const SET_FORM_FIELD_INVALID = 'Payments.SET_FORM_FIELD_INVALID'
export const RESET_FORM_FIELD_VALIDITY = 'Payments.RESET_FORM_FIELD_VALIDITY'
export const SET_FORM_VALUES = 'Payments.SET_FORM_VALUES'
export const SET_BILLING_ADDRESS_SAME_AS_SHIPPING = 'Payments.SET_BILLING_ADDRESS_SAME_AS_SHIPPING'
export const SET_STRIPE_PAYMENT_METHOD = 'Payments.SET_STRIPE_PAYMENT_METHOD'
export const SET_EDITING_CHECKOUT_SHIPPING_ADDRESS = 'Payments.SET_EDITING_CHECKOUT_SHIPPING_ADDRESS'
export const SET_SHIPPING_METHOD = 'Payments.SET_SHIPPING_METHOD'
export const SET_PAYMENT_PAGE = 'Payments.SET_PAYMENT_PAGE'
export const GOTO_ITEM_DETAILS_PAGE = 'Payments.GOTO_ITEM_DETAILS_PAGE'
export const GOTO_SHIPPING_ADDRESS_PAGE = 'Payments.GOTO_SHIPPING_ADDRESS_PAGE'
export const GOTO_PAYMENT_METHOD_PAGE = 'Payments.GOTO_PAYMENT_METHOD_PAGE'
export const GOTO_CHECKOUT_PAGE = 'Payments.GOTO_CHECKOUT_PAGE'
export const GOTO_ORDER_COMPLETE_PAGE = 'Payments.GOTO_ORDER_COMPLETE_PAGE'

export const OPEN_PAYMENT_OAUTH_WINDOW = 'Payments.OPEN_PAYMENT_OAUTH_WINDOW'
export const CLOSE_PAYMENT_OAUTH_WINDOW = 'Payments.CLOSE_PAYMENT_OAUTH_WINDOW'
export const SET_USER_AUTHENTICATED = 'Payments.SET_USER_AUTHENTICATED'

export const CLEAR_ORDER_DATA = 'Payments.CLEAR_ORDER_DATA'

export const SET_PLATFORM = 'Payments.SET_PLATFORM'

export const SET_ITEM_CATALOG = 'Payments.SET_ITEM_CATALOG'
export const SET_ITEM_VARIANT = 'Payments.SET_ITEM_VARIANT'
export const SET_SELECTED_ITEM = 'Payments.SET_SELECTED_ITEM'
export const SET_CREDIT_CARD_OPTION = 'Payments.SET_CREDIT_CARD_OPTION'
export const SET_CREDIT_CARDS = 'Payments.SET_CREDIT_CARDS'

export const DETAILS_FORM_SUBMITTED = 'Payments.DETAILS_FORM_SUBMITTED'

//TODO
//Use new action constants
export const ITEMS_AVAILABLE = 'Payments.ITEMS_AVAILABLE'
export const OPEN_PAYMENTS_MODAL = 'Payments.OPEN_PAYMENTS_MODAL'
export const CLOSE_PAYMENTS_MODAL = 'Payments.CLOSE_PAYMENTS_MODAL'
export const CLOSE_PAYMENTS_MODAL_BUTTON_CLICKED = 'Payments.CLOSE_PAYMENTS_MODAL_BUTTON_CLICKED'
export const PRODUCT_DETAILS_OPENED = 'Payments.PRODUCT_DETAILS_OPENED'
export const PRODUCT_DETAILS_CLOSED = 'Payments.PRODUCT_DETAILS_CLOSED'
export const GUEST_SIGNUP = 'Payments.GUEST_SIGNUP'
export const EXPRESS_CHECKOUT_AVAILABLE = 'Payments.EXPRESS_CHECKOUT_AVAILABLE'
export const EXPRESS_CHECKOUT_CLICKED = 'Payments.EXPRESS_CHECKOUT_CLICKED'
export const PRODUCT_SHIPPING_OPENED = 'Payments.PRODUCT_SHIPPING_OPENED'
export const SHIPPING_DETAILS_SUBMITTED = 'Payments.SHIPPING_DETAILS_SUBMITTED'
export const PAYMENT_METHOD_OPENED = 'Payments.PAYMENT_METHOD_OPENED'
export const PAYMENT_METHOD_SUBMITTED = 'Payments.PAYMENT_METHOD_SUBMITTED'
export const ORDER_DETAILS_OPENED = 'Payments.ORDER_DETAILS_OPENED'
export const ORDER_DETAILS_SUBMITTED = 'Payments.ORDER_DETAILS_SUBMITTED'
export const ORDER_PAYMENT_SUCCESS = 'Payments.ORDER_PAYMENT_SUCCESS'
export const ORDER_DETAILS_CLOSED = 'Payments.ORDER_DETAILS_CLOSED'
export const ORDER_CONFIRMATION_OPENED = 'Payments.ORDER_CONFIRMATION_OPENED'
export const ORDER_CONFIRMATION_CLOSED = 'Payments.ORDER_CONFIRMATION_CLOSED'

export const ITEM_IDLE_TIME = 'Payments.ITEM_IDLE_TIME'
export const ITEM_NEXT_IMAGE_CLICKED = 'Payments.ITEM_NEXT_IMAGE_CLICKED'
export const ITEM_PREV_IMAGE_CLICKED = 'Payments.ITEM_PREV_IMAGE_CLICKED'
export const SET_SELECTED_ITEM_VARIANT = 'Payments.SET_SELECTED_ITEM_VARIANT'
export const SET_ITEM_QUANTITY = 'Payments.SET_ITEM_QUANTITY'
export const SET_ITEM_UNIT_COST = 'Payments.SET_ITEM_UNIT_COST'
export const SET_ITEM_TAX = 'Payments.SET_ITEM_TAX'
export const SET_ITEM_TRANSACTION_ID = 'Payments.SET_ITEM_TRANSACTION_ID'
export const SET_ITEM_TRANSACTION_STATUS = 'Payments.SET_ITEM_TRANSACTION_STATUS'
export const CONTINUE_SHOPPING_CLICKED = 'Payments.CONTINUE_SHOPPING_CLICKED'
export const SET_AUTH_POPUP_VISIBILITY = 'Payments.SET_AUTH_POPUP_VISIBILITY'
export const SET_REQUIRED_FIELDS = 'Payments.SET_REQUIRED_FIELDS'
export const SET_FIELD_VALIDATIONS = 'Payments.SET_FIELD_VALIDATIONS'
export const SET_IS_USER_EDITING_ITEM_DETAILS = 'Payments.SET_IS_USER_EDITING_ITEM_DETAILS'
export const SET_FORM_PROCESSING = 'Payments.SET_FORM_PROCESSING'

export const SET_ACCOUNT_NETWORKS = 'Payments.SET_ACCOUNT_NETWORKS'

export const PAYMENT_CLICKED = 'Payments.PAYMENT_CLICKED[A]'
export const PAYMENT_MOUSE_ENTERED = 'Payments.PAYMENT_MOUSE_ENTERED[A]'
export const PAYMENT_MOUSE_EXITED = 'Payments.PAYMENT_MOUSE_EXITED[A]'

export const SET_STRIPE_PROPERTIES = 'Payments.SET_STRIPE_PROPERTIES'
export const SET_STRIPE_FIELD_COMPLETE_STATUS = 'Payments.SET_STRIPE_FIELD_COMPLETE_STATUS'
export const SET_API_KEY = 'Payments.SET_API_KEY'
export const SET_PAYMENT_TRANSACTION_TIMESTAMP = 'Payments.SET_PAYMENT_TRANSACTION_TIMESTAMP'
export const SET_SHIPPING_METHODS_OPTIONS = 'Payments.SET_SHIPPING_METHODS_OPTIONS'

export const RESET_PAYMENT_FORM_VALUES = 'Payments.RESET_PAYMENT_FORM_VALUES'

export const UPDATE_HAS_EXPRESS_CHECKOUT = 'Payments.UPDATE_HAS_EXPRESS_CHECKOUT'
export const UPDATE_HAS_REQUIRED_FIELDS = 'Payments.UPDATE_HAS_REQUIRED_FIELDS'
export const SET_IS_ITEM_DESCRIPTION_TRUNCATED = 'Payments.SET_IS_ITEM_DESCRIPTION_TRUNCATED'
export const SET_PAYMENT_ENABLED = 'Payments.SET_PAYMENT_ENABLED'

export const setAPIKey = APIKey => ({
    type: SET_API_KEY,
    APIKey,
})

export const setIsPaymentEnabled = ({ enabled }) => {
    return {
        type: SET_PAYMENT_ENABLED,
        enabled,
    }
}

export const setIsItemDescriptionTruncated = ({ isTruncated }) => {
    return {
        type: SET_IS_ITEM_DESCRIPTION_TRUNCATED,
        isTruncated,
    }
}

export const setPaymentTransaction = timestamp => ({
    type: SET_PAYMENT_TRANSACTION_TIMESTAMP,
    timestamp,
})

export const updateHasExpressCheckout = () => ({
    type: UPDATE_HAS_EXPRESS_CHECKOUT,
})

export const updateHasRequiredFields = formName => ({
    type: UPDATE_HAS_REQUIRED_FIELDS,
    formName,
})

export const changeFormField = ({ formName, fieldId, value }) => {
    return (dispatch, getState) => {
        dispatch([
            {
                type: CHANGE_FORM_FIELD,
                fieldId,
                value,
                formName,
            },
            updateHasRequiredFields(formName),
        ])

        if (fieldId == 'zipcode' && value.length >= 5) {
            autoCompleteCityAndStateFromZipCode({
                formName,
                fieldId,
                value,
            })(dispatch, getState)
        }
    }
}

export const blurFormField = ({ formName, fieldId, value }) => {
    return (dispatch, getState) => {
        const state = getState()
        const validationFields = state.getIn(['payments', formName, 'validationFields'])
        const requiredFields = state.getIn(['payments', formName, 'requiredFields'])
        const errors = state.getIn(['payments', formName, 'errors'])

        // Determine field validity
        const fieldValidation = validationFields.find(field => field.id == fieldId)

        if (fieldValidation && !fieldValidation.validation(value)) {
            return dispatch(
                setFormFieldInvalid({
                    formName,
                    fieldId,
                    message: fieldValidation.errorMessage || '',
                })
            )
        }

        // Determine if field is required and not empty
        const fieldRequired = requiredFields.find(field => field == fieldId)

        if (!fieldValidation && fieldRequired && value == '') {
            return dispatch(
                setFormFieldInvalid({
                    formName,
                    fieldId,
                    message: 'Must fill out all required fields!',
                })
            )
        }

        // Reset field if no error is present
        if (errors.get(fieldId) != undefined) {
            return dispatch(resetFormFieldValidity({ formName, fieldId }))
        }
    }
}

export const resetFormFieldValidity = ({ formName, fieldId }) => ({
    type: RESET_FORM_FIELD_VALIDITY,
    formName,
    fieldId,
})

const autoCompleteCityAndStateFromZipCode = ({ formName, fieldId, value }) => {
    return (dispatch, getState) => {
        geocodeByAddress(value)
            .then(place => Places.getAddress(place))
            .then(address => {
                if (address.country == 'US') {
                    dispatch([
                        {
                            type: CHANGE_FORM_FIELD,
                            fieldId: 'town',
                            value: address.city,
                            formName,
                        },
                        {
                            type: CHANGE_FORM_FIELD,
                            fieldId: 'state',
                            value: address.state,
                            formName,
                        },
                        resetFormFieldValidity({ formName, fieldId: 'town' }),
                        resetFormFieldValidity({ formName, fieldId: 'state' }),
                        updateHasRequiredFields(formName),
                    ])
                } else {
                    dispatch(setFormFieldInvalid({ formName, fieldId: 'zipcode', message: 'Invalide US zip code!' }))
                }
            })
    }
}

const setBatchFormFieldsInvalid = ({ fields }) => {
    const batchedFields = fields.map(fieldError => {
        return setFormFieldInvalid({
            formName: fieldError.formName,
            fieldId: fieldError.fieldId,
            message: fieldError.message,
        })
    })

    return batchedFields
}

export const setFormFieldInvalid = ({ formName, fieldId, message }) => ({
    type: SET_FORM_FIELD_INVALID,
    fieldId,
    message,
    formName,
})

export const setFormValues = ({ values, formName }) => {
    return {
        type: SET_FORM_VALUES,
        values,
        formName,
    }
}

export const setBillingAddressSameAsShipping = ({ enabled }) => ({
    type: SET_BILLING_ADDRESS_SAME_AS_SHIPPING,
    enabled,
})

export const setAccountNetworks = ({ networks }) => ({
    type: SET_ACCOUNT_NETWORKS,
    networks,
})

export const setStripePaymentMethod = ({ values }) => {
    return {
        type: SET_STRIPE_PAYMENT_METHOD,
        values,
    }
}

export const onVariantOptionClick = ({ optionKey }, { optionId }) => (dispatch, getState) => {
    const itemSelectedVariants = getState().getIn(['payments', 'selectedItemDetails', 'selectedVariants'])

    const colorNeedsUpdate = itemSelectedVariants[optionKey] != optionId

    if (colorNeedsUpdate) {
        dispatch(
            setItemVariant({
                variantKey: optionKey,
                variantValue: optionId,
            })
        )
    }
}

export const onAuthButtonClick = ({ type }) => {
    switch (type) {
        case PaymentConstants.userAuthTypes.FACEBOOK:
        case PaymentConstants.userAuthTypes.GOOGLE:
            return openPaymentOAuthWindow({
                authType: type,
            })
        default:
            return guestCheckoutClick()
    }
}

export const addItemQuantity = () => (dispatch, getState) => {
    const quantity = getState().getIn(['payments', 'itemCostCalculator', 'itemQuantity']) + 1

    dispatch(
        setItemQuantity({
            quantity,
        })
    )
}

export const reduceItemQuantity = () => (dispatch, getState) => {
    const quantity = Math.max(getState().getIn(['payments', 'itemCostCalculator', 'itemQuantity']) - 1, 1)

    dispatch(
        setItemQuantity({
            quantity,
        })
    )
}

export const setItemQuantity = ({ quantity }) => ({
    type: SET_ITEM_QUANTITY,
    quantity,
})

export const setItemUnitCost = ({ itemUnitCost }) => ({
    type: SET_ITEM_UNIT_COST,
    itemUnitCost,
})

export const setItemTax = ({ itemTax }) => ({
    type: SET_ITEM_TAX,
    itemTax,
})

export const setItemTransactionId = ({ transactionId }) => ({
    type: SET_ITEM_TRANSACTION_ID,
    transactionId,
})

export const setItemTransactionStatus = ({ status }) => ({
    type: SET_ITEM_TRANSACTION_STATUS,
    status,
})

export const setEditingCheckoutShippingAddress = ({ editing }) => ({
    type: SET_EDITING_CHECKOUT_SHIPPING_ADDRESS,
    editing,
})

export const setPaymentItemCatalog = ({ catalog }) => ({
    type: SET_ITEM_CATALOG,
    catalog,
})

export const setSelectedPaymentItem = ({ itemId, item }) => ({
    type: SET_SELECTED_ITEM,
    itemId,
    item,
})

export const setItemVariant = ({ itemId, variant, variantKey, variantValue }) => ({
    type: SET_ITEM_VARIANT,
    itemId,
    variant,
    variantKey,
    variantValue,
})

export const setPaymentPage = ({ pageName, fromHistory = false }) => {
    //If this action wasn't set from the history...
    //we must record the new state
    //dont record complete and checkout page
    if (!fromHistory && ![GOTO_ORDER_COMPLETE_PAGE].includes(pageName)) {
        const stateObj = {
            paymentPageName: pageName,
        }
        history.pushState(stateObj, '')
    }

    return {
        type: SET_PAYMENT_PAGE,
        pageName,
    }
}

export const resetPaymentFormValues = ({ formName }) => {
    return {
        type: RESET_PAYMENT_FORM_VALUES,
        formName,
    }
}

export const paymentDetailsFormSubmitted = ({ onSubmit }) => (dispatch, getState) => {
    const paymentsState = getState().get('payments')
    const hasExpressCheckout = paymentsState.get('hasExpressCheckout')
    const isUserAuthenticated = paymentsState.get('isUserAuthenticated')

    onSubmit && onSubmit()

    if (hasExpressCheckout && isUserAuthenticated) {
        dispatch(gotoCheckoutPage())
    } else {
        dispatch({
            type: DETAILS_FORM_SUBMITTED,
        })
    }
}

export const paymentCheckoutFormSubmitted = ({ onSubmit, checkoutErrors, isFormProcessing }) => (
    dispatch,
    getState
) => {
    if (isFormProcessing) return

    dispatch(orderDetailsSubmitted())

    if (checkoutErrors.size == 0) {
        //Ok to submit the form
        dispatch(orderPaymentSuccess())
        onSubmit && onSubmit()
    }
}

export const paymentMethodFormSubmitted = ({ paymentFormErrors }) => (dispatch, getState) => {
    if (paymentFormErrors.size == 0) {
        //this tells the stripeform that it should submit itself
        dispatch([
            { type: PAYMENT_METHOD_SUBMITTED },
            setStripeProperties({
                stripeProperties: { shouldSubmit: true },
            }),
        ])
    }
}

export const gotoItemDetailsPage = () => setPaymentPage({ pageName: GOTO_ITEM_DETAILS_PAGE })

export const gotoShippingAddressPage = () => setPaymentPage({ pageName: GOTO_SHIPPING_ADDRESS_PAGE })

export const gotoOrderCompletePage = () => setPaymentPage({ pageName: GOTO_ORDER_COMPLETE_PAGE })

const guestCheckoutClick = () => [{ type: GUEST_SIGNUP }, setAuthPopup({ isVisible: false }), gotoShippingAddressPage()]

export const setPaymentShippingMethodsOptions = ({ shippingOptions }) => {
    return {
        type: SET_SHIPPING_METHODS_OPTIONS,
        shippingOptions,
    }
}

export const setShippingMethod = ({ shippingMethodId, price }) => ({
    type: SET_SHIPPING_METHOD,
    shippingMethodId,
    price,
})

export const openPaymentsModal = () => ({
    type: OPEN_PAYMENTS_MODAL,
})

export const CloseActions = {
    CLOSE: 'close',
    CONTINUE: 'continue',
}

export const closePaymentsModal = (evt, intitatedBy = CloseActions.CLOSE) => (dispatch, getState) => {
    const paymentPageName = getState().getIn(['payments', 'paymentPageName'])
    const isCompletedPage = paymentPageName == GOTO_ORDER_COMPLETE_PAGE

    const confirmCloseModal = !isCompletedPage ? confirm('Are you sure you want to exit?') : false

    if (confirmCloseModal || isCompletedPage) {
        let actions = [
            {
                type: CLOSE_PAYMENTS_MODAL,
            },
            setIsItemDescriptionTruncated({ isTruncated: true }),
            closeModal(),
        ]

        if (intitatedBy == CloseActions.CLOSE) actions.splice(0, 0, { type: CLOSE_PAYMENTS_MODAL_BUTTON_CLICKED })

        if (paymentPageName == GOTO_ORDER_COMPLETE_PAGE) actions.splice(0, 0, clearOrderData())

        dispatch(actions)
    }
}

export const productShippingOpened = () => ({
    type: PRODUCT_SHIPPING_OPENED,
})

export const paymentFormOpened = ({ defaultFields = [], formName }) => {
    return (dispatch, getState) => {
        if (formName && defaultFields.length > 0) {
            const requiredFields = defaultFields.filter(field => field.required).map(requiredField => requiredField.id)

            const validationFields = defaultFields
                .filter(field => typeof field.validation == 'function')
                .map(validationField => ({
                    id: validationField.id,
                    validation: validationField.validation,
                    errorMessage: validationField.errorMessage,
                }))

            dispatch([
                {
                    type: SET_REQUIRED_FIELDS,
                    requiredFields,
                    formName,
                },
                {
                    type: SET_FIELD_VALIDATIONS,
                    validationFields,
                    formName,
                },
            ])
        }
    }
}

export const shippingDetailsSubmitted = ({ onSubmit, shippingFormErrors }) => (dispatch, getState) => {
    if (shippingFormErrors.size == 0) {
        //Ok to submit the form
        onSubmit && onSubmit()

        dispatch({
            type: SHIPPING_DETAILS_SUBMITTED,
        })
    }
}

export const paymentDetailsMounted = ({ hasExpressCheckout }) => (dispatch, getState) => {
    if (hasExpressCheckout) dispatch({ type: EXPRESS_CHECKOUT_AVAILABLE })
}

export const paymentMethodMounted = () => ({
    type: PAYMENT_METHOD_OPENED,
})

export const paymentDetailsExpressCheckoutClick = () => (dispatch, getState) => {
    dispatch({ type: EXPRESS_CHECKOUT_CLICKED })

    // didn't want to just pass in true so i assigned it to a variable to be more verbal
    const isExpressCheckout = true
    executePaymentTransaction(isExpressCheckout)(dispatch, getState)
}

export const orderDetailsOpened = () => ({
    type: ORDER_DETAILS_OPENED,
})
export const orderDetailsSubmitted = () => ({
    type: ORDER_DETAILS_SUBMITTED,
})

export const orderPaymentSuccess = () => ({
    type: ORDER_PAYMENT_SUCCESS,
})
export const orderConfirmationOpened = () => ({
    type: ORDER_CONFIRMATION_OPENED,
})
export const orderConfirmationClosed = ({ initiatedBy }) => ({
    type: ORDER_CONFIRMATION_CLOSED,
    initiatedBy,
})
export const setCreditCardOption = ({ value }) => ({
    type: SET_CREDIT_CARD_OPTION,
    value,
})

export const setCreditCards = ({ creditCards }) => ({
    type: SET_CREDIT_CARDS,
    creditCards,
})

export const setAuthPopup = ({ isVisible }) => ({
    type: SET_AUTH_POPUP_VISIBILITY,
    isVisible,
})

export const toggleEditingShippingAddress = ({ editingShippingAddress, hasRequiredShippingFields }) => (
    dispatch,
    getState
) => {
    if (hasRequiredShippingFields) {
        dispatch(
            setEditingCheckoutShippingAddress({
                editing: !editingShippingAddress,
            })
        )
    }
}

/*********************************
			ANALYTICS
**********************************/

//For now, these are actions reserved for analytics
export const paymentClicked = () => ({
    type: PAYMENT_CLICKED,
})

export const paymentMouseEntered = ({ id }) => [
    {
        type: PAYMENT_MOUSE_ENTERED,
    },
    setHoveredHotspotId({ id }),
]

export const paymentMouseExited = ({ id }) => (dispatch, getState) => {
    let actions = [
        {
            type: PAYMENT_MOUSE_EXITED,
        },
        setHoveredHotspotId({ id }),
    ]

    dispatch(actions)
}

export const productDetailsOpened = ({ isUserAuthenticated }) => {
    return (dispatch, getState) => {
        let actions = [
            {
                type: PRODUCT_DETAILS_OPENED,
            },
            gotoItemDetailsPage(),
        ]
        addPostMessageListener({ dispatch, isUserAuthenticated })
        dispatch(actions)
    }
}

export const productDetailsClosed = () => {
    removePostMessageListener()
    return {
        type: PRODUCT_DETAILS_CLOSED,
    }
}

/*********************************
			ANALYTICS
**********************************/

/*********************************
				OAUTH
**********************************/

const openPaymentOAuthWindow = ({ authType }) => {
    const url = `${window.location.origin}/social/${authType}?type=Customer&forward=%2Fpayments%2Foauth.php`

    //this function opens the popup window
    const popupWindow = ({ url, title, win, width, height }) => {
        //this will position the window in the center of the parent window
        const y = win.top.outerHeight / 2 + win.top.screenY - height / 2
        const x = win.top.outerWidth / 2 + win.top.screenX - width / 2
        const options = `width=${width}, height=${height}, top=${y}, left=${x}`

        return win.open(url, title, options)
    }

    popupWindow({
        url,
        title: '_blank',
        win: window,
        width: '500',
        height: '500',
    })

    return {
        type: OPEN_PAYMENT_OAUTH_WINDOW,
        oauthState: {
            isOpen: true,
            authType,
        },
    }
}

export const closePaymentOAuthWindow = () => ({
    type: CLOSE_PAYMENT_OAUTH_WINDOW,
    oauthState: {
        isOpen: false,
        authType: null,
    },
})

export const setIsUserAuthenticated = ({ isAuthenticated }) => ({
    type: SET_USER_AUTHENTICATED,
    isAuthenticated,
})

// Keep a reference of the window message callback
let messageCallback

const addPostMessageListener = ({ dispatch, isUserAuthenticated }) => {
    if (!isUserAuthenticated) {
        messageCallback = handleOnMessageCallback(dispatch)

        window.addEventListener('message', messageCallback)
    }
}

const handleOnMessageCallback = dispatch => event => {
    if (event.origin != window.origin) return

    const oauthData = event.data
    if (oauthData.sessionId) {
        ajax.getApi(PaymentConstants.apiEndpoints.ACCOUNT_NETWORKS, { withCredentials: true }).then(({ data }) => {
            const stripeCustomer = (data || []).find(
                accountNetwork => accountNetwork.network == PaymentConstants.networks.STRIPE
            )
            let paymentActions = [
                setIsUserAuthenticated({ isAuthenticated: true }),
                closePaymentOAuthWindow(),
                gotoShippingAddressPage(),
            ]
            if (stripeCustomer) {
                const {
                    network,
                    foreignId,
                    id,
                    shippingCity,
                    shippingCountry,
                    shippingLine1,
                    shippingName,
                    shippingPostalCode,
                    shippingState,
                    email,
                    phone,
                    creditCards,
                } = stripeCustomer

                const creditCardsMap = formatCreditCardsMap({
                    creditCards: creditCards,
                })

                paymentActions = [
                    setAccountNetworks({
                        networks: {
                            [network]: {
                                foreignId,
                                id,
                            },
                        },
                    }),
                    setFormValues({
                        formName: PaymentConstants.formNames.SHIPPING_ADDRESS,
                        values: {
                            fullName: shippingName || oauthData.fullName || '',
                            address: shippingLine1,
                            zipcode: `${shippingPostalCode}`,
                            town: shippingCity,
                            //country: shippingCountry, // No need to set country as currently we're only supporting US
                            state: shippingState,
                            email: email || oauthData.email || '',
                            phone: phone ? phone : '',
                        },
                    }),
                    updateHasRequiredFields(PaymentConstants.formNames.SHIPPING_ADDRESS),
                    setCreditCards({ creditCards: creditCardsMap }),
                    updateHasExpressCheckout(),
                    ...paymentActions,
                ]
            } else {
                paymentActions = [
                    setFormValues({
                        formName: PaymentConstants.formNames.SHIPPING_ADDRESS,
                        values: {
                            fullName: oauthData.fullName || '',
                            email: oauthData.email || '',
                        },
                    }),
                    ...paymentActions,
                ]
            }

            dispatch(paymentActions)
        })
    }
}

const removePostMessageListener = () => {
    window.removeEventListener('message', messageCallback)
}

/*********************************
				OAUTH
**********************************/

export const gotoPaymentMethodPage = () => {
    return (dispatch, getState) => {
        const paymentsState = getState().get('payments')
        const shippingAddress = paymentsState.getIn([PaymentConstants.formNames.SHIPPING_ADDRESS, 'values'])
        const { id: accountNetworkID } =
            paymentsState.getIn(['accountNetworks', PaymentConstants.networks.STRIPE]) || {}
        const userHasStripeAccount = accountNetworkID !== undefined

        const endpoint = userHasStripeAccount
            ? PaymentConstants.apiEndpoints.ACCOUNT_NETWORKS + '/' + accountNetworkID
            : PaymentConstants.apiEndpoints.ACCOUNT_NETWORKS
        const httpVerb = userHasStripeAccount ? PaymentConstants.httpVerb.PUT : PaymentConstants.httpVerb.POST

        let data = {
            shippingName: shippingAddress.get('fullName'),
            shippingLine1: shippingAddress.get('address'),
            shippingCity: shippingAddress.get('town'),
            shippingState: shippingAddress.get('state'),
            shippingPostalCode: shippingAddress.get('zipcode'),
            shippingCountry: shippingAddress.get('country'),
        }

        if (!userHasStripeAccount) data['network'] = PaymentConstants.networks.STRIPE

        const config = { withCredentials: true }

        dispatch(setFormProcessing({ isProcessing: true, formName: PaymentConstants.formNames.SHIPPING_ADDRESS }))

        ajax[httpVerb](endpoint, data, config).then(({ data }) => {
            if (data.error) {
                dispatch({
                    type: TourActions.ERROR,
                    value: {
                        message: data.error,
                    },
                })
            } else {
                let actions = [
                    setFormProcessing({
                        isProcessing: false,
                        formName: PaymentConstants.formNames.SHIPPING_ADDRESS,
                    }),
                ]

                const { network, foreignId, id } = data

                if (network) {
                    const networks = {
                        [network]: {
                            foreignId,
                            id,
                        },
                    }

                    actions.push(setAccountNetworks({ networks }))
                }

                actions.push(setPaymentPage({ pageName: GOTO_PAYMENT_METHOD_PAGE }))

                dispatch(actions)
            }
        })
    }
}

export const gotoCheckoutPage = () => setPaymentPage({ pageName: GOTO_CHECKOUT_PAGE })

export const setStripeProperties = ({ stripeProperties }) => {
    return {
        type: SET_STRIPE_PROPERTIES,
        stripeProperties,
    }
}

export const setFormProcessing = ({ isProcessing, formName }) => ({
    type: SET_FORM_PROCESSING,
    isProcessing,
    formName,
})

export const setStripeFieldCompleteStatus = ({ fieldName, event }) => {
    return (dispatch, getState) => {
        let isComplete = event.complete
        let actions = []
        if (fieldName === PaymentConstants.stripeFieldNames.CARD_HOLDER_NAME) {
            isComplete = event.target.value
        }

        if (event && event.error) {
            actions.push(
                setFormFieldInvalid({
                    formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    fieldId: fieldName,
                    message: event.error.message,
                })
            )
        } else {
            actions.push(
                resetFormFieldValidity({
                    formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    fieldId: fieldName,
                })
            )
        }

        actions.push({
            type: SET_STRIPE_FIELD_COMPLETE_STATUS,
            fieldName,
            isComplete,
        })

        dispatch(actions)
    }
}

export const executePaymentTransaction = isExpressCheckout => {
    return (dispatch, getState) => {
        const state = getState()
        const paymentState = state.get('payments')
        const paymentCheckoutState = paymentState.get(PaymentConstants.formNames.CHECKOUT)
        const itemDetails = paymentState.get('selectedItemDetails')

        let endpoint = PaymentConstants.apiEndpoints.TRANSACTIONS

        //if it's NOT expresscheckout, append the itemtransactionid
        if (!isExpressCheckout) {
            endpoint = endpoint + '/' + paymentCheckoutState.get('itemTransactionId')
        }

        dispatch([setItemTransactionStatus({ status: PaymentConstants.transactionStatus.CHARGED })])

        const config = { withCredentials: true }

        //set orderprocessing status
        dispatch(setFormProcessing({ isProcessing: true, formName: PaymentConstants.formNames.CHECKOUT }))

        let httpVerb = PaymentConstants.httpVerb.PUT
        let data = {
            locId: itemDetails.get('loc_id'),
            status: PaymentConstants.transactionStatus.CHARGED,
        }

        if (isExpressCheckout) {
            const itemCostCalculator = paymentState.get('itemCostCalculator')
            httpVerb = PaymentConstants.httpVerb.POST
            data = {
                ...data,
                quantity: itemCostCalculator.get('itemQuantity'),
                shipPrice: itemCostCalculator.get('itemShippingCost'),
                paymentsProductSkuId: itemDetails.get('payments_product_sku_id'),
            }
        }

        ajax[httpVerb](endpoint, data, config).then(({ data, error }) => {
            let actionBatch = [
                setFormProcessing({ isProcessing: false, formName: PaymentConstants.formNames.CHECKOUT }),
                setStripeProperties({
                    stripeProperties: {
                        shouldSubmit: false,
                    },
                }),
                setItemTransactionStatus({ status: null }),
            ]

            if (error) {
                dispatch([
                    setFormFieldInvalid({
                        formName: PaymentConstants.formNames.CHECKOUT,
                        fieldId: 'message',
                        message: error,
                    }),
                    setItemTransactionStatus({ status: PaymentConstants.transactionStatus.FAILED }),
                ])
            } else if (data == undefined) {
                dispatch([
                    setFormFieldInvalid({
                        formName: PaymentConstants.formNames.CHECKOUT,
                        fieldId: 'message',
                        message: 'Payment Failed. Please try again later.',
                    }),
                    setItemTransactionStatus({ status: PaymentConstants.transactionStatus.FAILED }),
                ])
            } else {
                actionBatch = [
                    ...actionBatch,
                    gotoOrderCompletePage(),
                    clearOrderData(),
                    setPaymentTransaction(Date.now()),
                ]

                dispatch(actionBatch)
            }
        })
    }
}

const getTaxRate = ({ accountNetworksData, name, token, cardInfo, billingAddress, shippingAddress }) => {
    return (dispatch, getState) => {
        const state = getState()
        const paymentsState = state.get('payments')

        const itemDetails = paymentsState.get('selectedItemDetails')

        const currentLocationIndex = state.getIn(['tour', 'locations', 'current'])
        const locationList = state.getIn(['tour', 'locations', 'list'])
        const { loc_id } = locationList[currentLocationIndex]
        const taxRates = {
            endpoint: PaymentConstants.apiEndpoints.TRANSACTIONS,
            params: {
                paymentsProductSkuId: itemDetails.get('payments_product_sku_id'),
                locId: loc_id,
                quantity: paymentsState.getIn(['itemCostCalculator', 'itemQuantity']),
                shipPrice: paymentsState.getIn(['itemCostCalculator', 'itemShippingCost']),
                billToAddress: {
                    street: billingAddress.get('address'),
                    city: billingAddress.get('town'),
                    stateCode: billingAddress.get('country') + '-' + billingAddress.get('state'),
                    postalCode: billingAddress.get('zipcode'),
                },
                shipToAddress: {
                    street: shippingAddress.get('address'),
                    city: shippingAddress.get('town'),
                    stateCode: shippingAddress.get('country') + '-' + shippingAddress.get('state'),
                    postalCode: shippingAddress.get('zipcode'),
                },
            },
            config: { withCredentials: true },
        }

        ajax.postApi(taxRates.endpoint, taxRates.params, taxRates.config).then(({ data }) => {
            const { tax_total, payments_transaction_id, status, price, error } = data
            let actionBatch = []
            if (error) {
                actionBatch = [
                    setFormProcessing({
                        isProcessing: false,
                        formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    }),
                    {
                        type: TourActions.ERROR,
                        value: {
                            message: error,
                        },
                    },
                ]
            } else {
                const cardValues = {
                    values: { name, token, cardInfo },
                }

                const creditCardsMap = formatCreditCardsMap({
                    creditCards: accountNetworksData.creditCards,
                })
                const itemTax = price * tax_total

                actionBatch = [
                    setFormProcessing({
                        isProcessing: false,
                        formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    }),
                    setItemTransactionId({ transactionId: payments_transaction_id }),
                    setItemTransactionStatus({ status }),
                    setItemTax({ itemTax }),
                    setStripePaymentMethod(cardValues),
                    setCreditCards({ creditCards: creditCardsMap }),
                    updateHasExpressCheckout(),
                    gotoCheckoutPage(),
                ]
            }
            dispatch(actionBatch)
        })
    }
}

const postPaymentMethodInfo = ({ name, token, cardInfo }) => {
    return (dispatch, getState) => {
        const state = getState()
        const paymentsState = state.get('payments')
        const { id: accountNetworkID } = paymentsState.getIn(['accountNetworks', PaymentConstants.networks.STRIPE])

        const shippingAddress = paymentsState.getIn([PaymentConstants.formNames.SHIPPING_ADDRESS, 'values'])
        const isBillingSameAsShipping = paymentsState.getIn([
            PaymentConstants.formNames.BILLING_ADDRESS,
            'sameAsShippingAddress',
        ])
        let billingAddress

        if (isBillingSameAsShipping) {
            billingAddress = shippingAddress
        } else {
            billingAddress = paymentsState.getIn([PaymentConstants.formNames.BILLING_ADDRESS, 'values'])
        }

        const { cardId } = cardInfo
        const accountNetworks = {
            endpoint: PaymentConstants.apiEndpoints.ACCOUNT_NETWORKS + '/' + accountNetworkID,
            params: {
                creditCardToken: token,
                creditCards: {
                    [cardId]: {
                        billingName: billingAddress.get('fullName'),
                        billingLine1: billingAddress.get('address'),
                        billingCity: billingAddress.get('town'),
                        billingState: billingAddress.get('state'),
                        billingPostalCode: billingAddress.get('zipcode'),
                        billingCountry: billingAddress.get('country'),
                    },
                },
                email: billingAddress.get('email'),
            },
            config: { withCredentials: true },
        }

        ajax.putApi(accountNetworks.endpoint, accountNetworks.params, accountNetworks.config).then(({ data }) => {
            if (data.error) {
                dispatch([
                    {
                        type: TourActions.ERROR,
                        value: {
                            message: data.error,
                        },
                    },
                    setFormProcessing({
                        isProcessing: false,
                        formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    }),
                ])
            } else {
                //we need to set the accountnetworks before we can get the taxrate
                getTaxRate({
                    accountNetworksData: data,
                    name,
                    token,
                    cardInfo,
                    billingAddress,
                    shippingAddress,
                })(dispatch, getState)
            }
        })
    }
}

//this apicall is made directly to stripe to retrieve the token
//it will not go through yv backend
export const getStripeToken = ({ stripeInstance }) => {
    return (dispatch, getState) => {
        const stripeState = getState().getIn([
            'payments',
            PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
            'stripeProperties',
        ])
        const stripeCardName = stripeState.get('cardName')

        dispatch(setFormProcessing({ isProcessing: true, formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD }))

        new Promise((resolve, reject) => {
            //this calls the stripe api to verify the card input
            //and returns a token for backend to process, the
            //cardNumberElement is the actual card element we pass in
            //from PaymentStripeCard
            if (stripeInstance && stripeCardName != '') {
                stripeInstance.createToken({ name: stripeCardName }).then(result => {
                    if (result.token) {
                        const stripeInfo = {
                            name: result.token.card.name,
                            token: result.token.id,
                            cardInfo: {
                                cardId: result.token.card.id,
                                last4: result.token.card.last4,
                                cardBrand: result.token.card.brand,
                            },
                        }
                        resolve({ stripeInfo })
                    } else {
                        reject({ setFormFieldInvalid, error: result.error })
                    }
                })
            } else {
                reject({ error: { message: "there's an error" } })
            }
        })
            .then(({ stripeInfo }) => {
                postPaymentMethodInfo(stripeInfo)(dispatch, getState)
            })
            .catch(({ setFormFieldInvalid, error }) => {
                let fieldId
                dispatch(
                    setFormProcessing({
                        isProcessing: false,
                        formName: PaymentConstants.formNames.STRIPE_PAYMENT_METHOD,
                    })
                )
                switch (error.code) {
                    case PaymentConstants.stripeErrorCode.CARD_EXP:
                        fieldId = PaymentConstants.stripeFieldNames.CARD_EXP
                        break
                    default:
                        fieldId = PaymentConstants.stripeFieldNames.CARD_NUMBER
                        break
                }
                setFormFieldInvalid &&
                    dispatch(
                        setFormFieldInvalid({
                            formName: 'paymentMethod',
                            fieldId: fieldId,
                            message: error.message,
                        })
                    )
            })
    }
}

export const clearOrderData = () => ({
    type: CLEAR_ORDER_DATA,
})

export const setIsUserEditingItemDetails = ({ isEditing }) => [
    {
        type: SET_IS_USER_EDITING_ITEM_DETAILS,
        isEditing,
    },
    isEditing ? gotoItemDetailsPage() : gotoCheckoutPage(),
]
